module.exports = __webpack_public_path__ + "static/img/about022.4284317.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about022.png
// module id = RhtE
// module chunks = 1